import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Voor welk object wilt u documenten bekijken?", -1)
const _hoisted_2 = { key: 2 }

import { computed, onMounted, ref, watch } from 'vue'
import SecureLS from 'secure-ls'
import Banner from '@/components/Banner.vue'
import Filelist from '@/components/Filelist.vue'
import { authStore } from '@/stores/auth'
import axios from 'axios'


export default /*#__PURE__*/_defineComponent({
  __name: 'Documents',
  setup(__props) {

const auth = authStore()

const documents = ref([])
const buildings = ref(new SecureLS({ isCompression: false }).get('buildings'))
const buildingId = ref<number|null>(auth.multipleObjects ? null : auth.buildingIds[0])
const activePanel = ref<string>(new SecureLS({ isCompression: false }).get('activeDocumentsPanel') || 'rentalDocumentation')
const loading = ref(false)
const screenWidth = computed(() => window.innerWidth)
const currentBuilding = computed(() => {
  let cb = null

  if (buildings.value.length && buildingId.value) {
    buildings.value.forEach((b:{ id:number, tenant_id:number }) => {
      if (b.id === buildingId.value) {
        cb = b
      }
    })
  }

  return cb
})

watch(() => buildingId.value, () => {
  if (buildingId.value) {
    getDocuments()
  }
})

onMounted(() => {
  if (buildingId.value) {
    getDocuments()
  }
})

function getDocuments () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/buildings/' + buildingId.value + '/documents').then((r) => {
    documents.value = r.data
  }).finally(() => {
    loading.value = false
  })
}

function setActivePanel (panel:string) : void {
  new SecureLS({ isCompression: false }).set('activeDocumentsPanel', panel)
  activePanel.value = panel
}

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          (buildings.value.length > 1)
            ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, {
                        title: "Selecteer object",
                        bordered: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                span: 24,
                                md: 12
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_1,
                                  _createVNode(_component_a_select, {
                                    style: {"width":"100%"},
                                    value: buildingId.value,
                                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((buildingId).value = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildings.value, (building) => {
                                        return (_openBlock(), _createBlock(_component_a_select_option, {
                                          value: building.id,
                                          key: building.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(building.address) + ", " + _toDisplayString(building.zipcode) + " " + _toDisplayString(building.city), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(currentBuilding))
            ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, {
                        title: "Documenten",
                        bordered: false,
                        loading: loading.value
                      }, {
                        default: _withCtx(() => [
                          (_unref(screenWidth) >= 768 && Object.keys(documents.value).length)
                            ? (_openBlock(), _createBlock(_component_a_tabs, {
                                key: 0,
                                "tab-position": "left",
                                animated: "",
                                activeKey: activePanel.value,
                                "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((activePanel).value = $event)),
                                onChange: setActivePanel
                              }, {
                                default: _withCtx(() => [
                                  (documents.value.verhuurdocumentatie)
                                    ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                        key: "rentalDocumentation",
                                        tab: "Verhuurdocumentatie"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Filelist, {
                                            "media-items": documents.value.verhuurdocumentatie.documents,
                                            "tenant-id": _unref(currentBuilding).tenant_id
                                          }, null, 8, ["media-items", "tenant-id"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (documents.value.huurcontract)
                                    ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                        key: "contracts",
                                        tab: "Huurcontract"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Filelist, {
                                            "media-items": documents.value.huurcontract.documents,
                                            "tenant-id": _unref(currentBuilding).tenant_id
                                          }, null, 8, ["media-items", "tenant-id"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (documents.value.gebruikershandleiding)
                                    ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                        key: "manuals",
                                        tab: "Gebruikershandleiding"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Filelist, {
                                            "media-items": documents.value.gebruikershandleiding.documents,
                                            "tenant-id": _unref(currentBuilding).tenant_id
                                          }, null, 8, ["media-items", "tenant-id"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (documents.value.overig)
                                    ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                        key: "other",
                                        tab: "Overig"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Filelist, {
                                            "media-items": documents.value.overig.documents,
                                            "tenant-id": _unref(currentBuilding).tenant_id
                                          }, null, 8, ["media-items", "tenant-id"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["activeKey"]))
                            : _createCommentVNode("", true),
                          (_unref(screenWidth) < 768 && Object.keys(documents.value).length)
                            ? (_openBlock(), _createBlock(_component_a_collapse, {
                                key: 1,
                                "tab-position": "left",
                                bordered: false,
                                activeKey: activePanel.value,
                                "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((activePanel).value = $event)),
                                onChange: setActivePanel
                              }, {
                                default: _withCtx(() => [
                                  (documents.value.verhuurdocumentatie)
                                    ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                        class: "option-collapsible-item",
                                        key: "rentalDocumentation",
                                        header: "Verhuurdocumentatie"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Filelist, {
                                            "media-items": documents.value.verhuurdocumentatie.documents,
                                            "tenant-id": _unref(currentBuilding).tenant_id
                                          }, null, 8, ["media-items", "tenant-id"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (documents.value.huurcontract)
                                    ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                        class: "option-collapsible-item",
                                        key: "contracts",
                                        header: "Huurcontract"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Filelist, {
                                            "media-items": documents.value.huurcontract.documents,
                                            "tenant-id": _unref(currentBuilding).tenant_id
                                          }, null, 8, ["media-items", "tenant-id"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (documents.value.gebruikershandleiding)
                                    ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                        class: "option-collapsible-item",
                                        key: "manuals",
                                        header: "Gebruikershandleiding"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Filelist, {
                                            "media-items": documents.value.gebruikershandleiding.documents,
                                            "tenant-id": _unref(currentBuilding).tenant_id
                                          }, null, 8, ["media-items", "tenant-id"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (documents.value.overig)
                                    ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                        class: "option-collapsible-item",
                                        key: "other",
                                        header: "Overig"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Filelist, {
                                            "media-items": documents.value.overig.documents,
                                            "tenant-id": _unref(currentBuilding).tenant_id
                                          }, null, 8, ["media-items", "tenant-id"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["activeKey"]))
                            : (!Object.keys(documents.value).length)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Er zijn (nog) geen documenten voor u beschikbaar."))
                              : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})